/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as MarketingRouteImport } from './routes/_marketing'
import { Route as ErrorRouteImport } from './routes/_error'
import { Route as DocsRouteImport } from './routes/_docs'
import { Route as AuthorizedRouteImport } from './routes/_authorized'
import { Route as MarketingIndexRouteImport } from './routes/_marketing/index'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthPasswordResetRouteImport } from './routes/auth/password-reset'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as MarketingTransparencyRouteImport } from './routes/_marketing/transparency'
import { Route as MarketingPricingRouteImport } from './routes/_marketing/pricing'
import { Route as MarketingFreeToolsRouteImport } from './routes/_marketing/free-tools'
import { Route as MarketingFeaturesRouteImport } from './routes/_marketing/features'
import { Route as MarketingDownloadRouteImport } from './routes/_marketing/download'
import { Route as MarketingContactRouteImport } from './routes/_marketing/contact'
import { Route as Error500RouteImport } from './routes/_error/500'
import { Route as Error404RouteImport } from './routes/_error/404'
import { Route as Error403RouteImport } from './routes/_error/403'
import { Route as AuthorizedDashboardRouteImport } from './routes/_authorized/dashboard'
import { Route as AuthorizedTeamRouteRouteImport } from './routes/_authorized/team/route'
import { Route as AuthVerifyEmailIndexRouteImport } from './routes/auth/verify-email/index'
import { Route as AuthResetPasswordIndexRouteImport } from './routes/auth/reset-password/index'
import { Route as MarketingToolsIndexRouteImport } from './routes/_marketing/tools/index'
import { Route as MarketingLegalIndexRouteImport } from './routes/_marketing/legal/index'
import { Route as MarketingDevelopersIndexRouteImport } from './routes/_marketing/developers/index'
import { Route as MarketingChangelogIndexRouteImport } from './routes/_marketing/changelog/index'
import { Route as MarketingBlogIndexRouteImport } from './routes/_marketing/blog/index'
import { Route as DocsDocsIndexRouteImport } from './routes/_docs/docs/index'
import { Route as AuthorizedAdminIndexRouteImport } from './routes/_authorized/admin/index'
import { Route as AuthVerifyEmailTokenRouteImport } from './routes/auth/verify-email/$token'
import { Route as AuthResetPasswordTokenRouteImport } from './routes/auth/reset-password/$token'
import { Route as AuthMfaRequiredRouteImport } from './routes/auth/mfa/required'
import { Route as AuthGoogleCallbackRouteImport } from './routes/auth/google/callback'
import { Route as AuthGithubCallbackRouteImport } from './routes/auth/github/callback'
import { Route as MarketingInboxLocalPartRouteImport } from './routes/_marketing/inbox.$localPart'
import { Route as MarketingForTestingRouteImport } from './routes/_marketing/for/testing'
import { Route as MarketingForSignUpRouteImport } from './routes/_marketing/for/sign-up'
import { Route as MarketingForNoRegistrationRouteImport } from './routes/_marketing/for/no-registration'
import { Route as MarketingDevelopersWebhooksRouteImport } from './routes/_marketing/developers/webhooks'
import { Route as MarketingChangelogArchiveRouteImport } from './routes/_marketing/changelog/archive'
import { Route as MarketingChangelogVersionRouteImport } from './routes/_marketing/changelog/$version'
import { Route as MarketingBlogPathRouteImport } from './routes/_marketing/blog/$path'
import { Route as MarketingAlternativesTempMailRouteImport } from './routes/_marketing/alternatives/temp-mail'
import { Route as MarketingAlternativesMailinatorRouteImport } from './routes/_marketing/alternatives/mailinator'
import { Route as MarketingAlternativesGuerrillaMailRouteImport } from './routes/_marketing/alternatives/guerrilla-mail'
import { Route as MarketingAlternatives10minutemailRouteImport } from './routes/_marketing/alternatives/10minutemail'
import { Route as DocsDocsSlugRouteImport } from './routes/_docs/docs/$slug'
import { Route as AuthorizedUserTeamsRouteImport } from './routes/_authorized/user/teams'
import { Route as AuthorizedUserSettingsRouteImport } from './routes/_authorized/user/settings'
import { Route as AuthorizedUserSecurityRouteImport } from './routes/_authorized/user/security'
import { Route as AuthorizedTeamSecurityRouteImport } from './routes/_authorized/team/security'
import { Route as AuthorizedTeamMembersRouteImport } from './routes/_authorized/team/members'
import { Route as MarketingLegalSlugRouteRouteImport } from './routes/_marketing/legal/$slug/route'
import { Route as AuthorizedTeamSettingsRouteRouteImport } from './routes/_authorized/team/settings/route'
import { Route as AuthorizedTeamNotificationsRouteRouteImport } from './routes/_authorized/team/notifications/route'
import { Route as AuthorizedTeamBillingRouteRouteImport } from './routes/_authorized/team/billing/route'
import { Route as MarketingLegalSlugIndexRouteImport } from './routes/_marketing/legal/$slug/index'
import { Route as MarketingDevelopersApiIndexRouteImport } from './routes/_marketing/developers/api/index'
import { Route as DocsDocsKnowledgeBaseIndexRouteImport } from './routes/_docs/docs/knowledge-base/index'
import { Route as DocsDocsApiReferenceIndexRouteImport } from './routes/_docs/docs/api-reference/index'
import { Route as AuthorizedTeamSettingsIndexRouteImport } from './routes/_authorized/team/settings/index'
import { Route as AuthorizedTeamNotificationsIndexRouteImport } from './routes/_authorized/team/notifications/index'
import { Route as AuthorizedTeamBillingIndexRouteImport } from './routes/_authorized/team/billing/index'
import { Route as AuthorizedAdminUsersIndexRouteImport } from './routes/_authorized/admin/users/index'
import { Route as AuthorizedAdminTeamsIndexRouteImport } from './routes/_authorized/admin/teams/index'
import { Route as MarketingLegalSlugVersionIdRouteImport } from './routes/_marketing/legal/$slug/$versionId'
import { Route as MarketingDevelopersApiSplatRouteImport } from './routes/_marketing/developers/api/$'
import { Route as DocsDocsKnowledgeBaseSlugRouteImport } from './routes/_docs/docs/knowledge-base/$slug'
import { Route as DocsDocsApiReferenceSplatRouteImport } from './routes/_docs/docs/api-reference/$'
import { Route as AuthorizedUserVerifyEmailTokenRouteImport } from './routes/_authorized/user/verify-email/$token'
import { Route as AuthorizedTeamSettingsApiKeysRouteImport } from './routes/_authorized/team/settings/api-keys'
import { Route as AuthorizedTeamNotificationsRulesRouteImport } from './routes/_authorized/team/notifications/rules'
import { Route as AuthorizedTeamNotificationsChannelsRouteImport } from './routes/_authorized/team/notifications/channels'
import { Route as AuthorizedTeamBillingUsageRouteImport } from './routes/_authorized/team/billing/usage'
import { Route as AuthorizedAdminUsersUserIdRouteImport } from './routes/_authorized/admin/users/$userId'
import { Route as AuthorizedAdminTeamsTeamIdRouteImport } from './routes/_authorized/admin/teams/$teamId'

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingRoute = MarketingRouteImport.update({
  id: '/_marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/_error',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/_docs',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthorizedRoute = AuthorizedRouteImport.update({
  id: '/_authorized',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketingRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPasswordResetRoute = AuthPasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const MarketingTransparencyRoute = MarketingTransparencyRouteImport.update({
  id: '/transparency',
  path: '/transparency',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingPricingRoute = MarketingPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingFreeToolsRoute = MarketingFreeToolsRouteImport.update({
  id: '/free-tools',
  path: '/free-tools',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingFeaturesRoute = MarketingFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingDownloadRoute = MarketingDownloadRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingContactRoute = MarketingContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => MarketingRoute,
} as any)
const Error500Route = Error500RouteImport.update({
  id: '/500',
  path: '/500',
  getParentRoute: () => ErrorRoute,
} as any)
const Error404Route = Error404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => ErrorRoute,
} as any)
const Error403Route = Error403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => ErrorRoute,
} as any)
const AuthorizedDashboardRoute = AuthorizedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthorizedRoute,
} as any)
const AuthorizedTeamRouteRoute = AuthorizedTeamRouteRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthorizedRoute,
} as any)
const AuthVerifyEmailIndexRoute = AuthVerifyEmailIndexRouteImport.update({
  id: '/verify-email/',
  path: '/verify-email/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordIndexRoute = AuthResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => AuthRoute,
} as any)
const MarketingToolsIndexRoute = MarketingToolsIndexRouteImport.update({
  id: '/tools/',
  path: '/tools/',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingLegalIndexRoute = MarketingLegalIndexRouteImport.update({
  id: '/legal/',
  path: '/legal/',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingDevelopersIndexRoute =
  MarketingDevelopersIndexRouteImport.update({
    id: '/developers/',
    path: '/developers/',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingChangelogIndexRoute = MarketingChangelogIndexRouteImport.update({
  id: '/changelog/',
  path: '/changelog/',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingBlogIndexRoute = MarketingBlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => MarketingRoute,
} as any)
const DocsDocsIndexRoute = DocsDocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => DocsRoute,
} as any)
const AuthorizedAdminIndexRoute = AuthorizedAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AuthorizedRoute,
} as any)
const AuthVerifyEmailTokenRoute = AuthVerifyEmailTokenRouteImport.update({
  id: '/verify-email/$token',
  path: '/verify-email/$token',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordTokenRoute = AuthResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMfaRequiredRoute = AuthMfaRequiredRouteImport.update({
  id: '/mfa/required',
  path: '/mfa/required',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGoogleCallbackRoute = AuthGoogleCallbackRouteImport.update({
  id: '/google/callback',
  path: '/google/callback',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGithubCallbackRoute = AuthGithubCallbackRouteImport.update({
  id: '/github/callback',
  path: '/github/callback',
  getParentRoute: () => AuthRoute,
} as any)
const MarketingInboxLocalPartRoute = MarketingInboxLocalPartRouteImport.update({
  id: '/inbox/$localPart',
  path: '/inbox/$localPart',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingForTestingRoute = MarketingForTestingRouteImport.update({
  id: '/for/testing',
  path: '/for/testing',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingForSignUpRoute = MarketingForSignUpRouteImport.update({
  id: '/for/sign-up',
  path: '/for/sign-up',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingForNoRegistrationRoute =
  MarketingForNoRegistrationRouteImport.update({
    id: '/for/no-registration',
    path: '/for/no-registration',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingDevelopersWebhooksRoute =
  MarketingDevelopersWebhooksRouteImport.update({
    id: '/developers/webhooks',
    path: '/developers/webhooks',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingChangelogArchiveRoute =
  MarketingChangelogArchiveRouteImport.update({
    id: '/changelog/archive',
    path: '/changelog/archive',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingChangelogVersionRoute =
  MarketingChangelogVersionRouteImport.update({
    id: '/changelog/$version',
    path: '/changelog/$version',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingBlogPathRoute = MarketingBlogPathRouteImport.update({
  id: '/blog/$path',
  path: '/blog/$path',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingAlternativesTempMailRoute =
  MarketingAlternativesTempMailRouteImport.update({
    id: '/alternatives/temp-mail',
    path: '/alternatives/temp-mail',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingAlternativesMailinatorRoute =
  MarketingAlternativesMailinatorRouteImport.update({
    id: '/alternatives/mailinator',
    path: '/alternatives/mailinator',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingAlternativesGuerrillaMailRoute =
  MarketingAlternativesGuerrillaMailRouteImport.update({
    id: '/alternatives/guerrilla-mail',
    path: '/alternatives/guerrilla-mail',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingAlternatives10minutemailRoute =
  MarketingAlternatives10minutemailRouteImport.update({
    id: '/alternatives/10minutemail',
    path: '/alternatives/10minutemail',
    getParentRoute: () => MarketingRoute,
  } as any)
const DocsDocsSlugRoute = DocsDocsSlugRouteImport.update({
  id: '/docs/$slug',
  path: '/docs/$slug',
  getParentRoute: () => DocsRoute,
} as any)
const AuthorizedUserTeamsRoute = AuthorizedUserTeamsRouteImport.update({
  id: '/user/teams',
  path: '/user/teams',
  getParentRoute: () => AuthorizedRoute,
} as any)
const AuthorizedUserSettingsRoute = AuthorizedUserSettingsRouteImport.update({
  id: '/user/settings',
  path: '/user/settings',
  getParentRoute: () => AuthorizedRoute,
} as any)
const AuthorizedUserSecurityRoute = AuthorizedUserSecurityRouteImport.update({
  id: '/user/security',
  path: '/user/security',
  getParentRoute: () => AuthorizedRoute,
} as any)
const AuthorizedTeamSecurityRoute = AuthorizedTeamSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthorizedTeamRouteRoute,
} as any)
const AuthorizedTeamMembersRoute = AuthorizedTeamMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AuthorizedTeamRouteRoute,
} as any)
const MarketingLegalSlugRouteRoute = MarketingLegalSlugRouteRouteImport.update({
  id: '/legal/$slug',
  path: '/legal/$slug',
  getParentRoute: () => MarketingRoute,
} as any)
const AuthorizedTeamSettingsRouteRoute =
  AuthorizedTeamSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthorizedTeamRouteRoute,
  } as any)
const AuthorizedTeamNotificationsRouteRoute =
  AuthorizedTeamNotificationsRouteRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthorizedTeamRouteRoute,
  } as any)
const AuthorizedTeamBillingRouteRoute =
  AuthorizedTeamBillingRouteRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthorizedTeamRouteRoute,
  } as any)
const MarketingLegalSlugIndexRoute = MarketingLegalSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketingLegalSlugRouteRoute,
} as any)
const MarketingDevelopersApiIndexRoute =
  MarketingDevelopersApiIndexRouteImport.update({
    id: '/developers/api/',
    path: '/developers/api/',
    getParentRoute: () => MarketingRoute,
  } as any)
const DocsDocsKnowledgeBaseIndexRoute =
  DocsDocsKnowledgeBaseIndexRouteImport.update({
    id: '/docs/knowledge-base/',
    path: '/docs/knowledge-base/',
    getParentRoute: () => DocsRoute,
  } as any)
const DocsDocsApiReferenceIndexRoute =
  DocsDocsApiReferenceIndexRouteImport.update({
    id: '/docs/api-reference/',
    path: '/docs/api-reference/',
    getParentRoute: () => DocsRoute,
  } as any).lazy(() =>
    import('./routes/_docs/docs/api-reference/index.lazy').then((d) => d.Route),
  )
const AuthorizedTeamSettingsIndexRoute =
  AuthorizedTeamSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthorizedTeamSettingsRouteRoute,
  } as any)
const AuthorizedTeamNotificationsIndexRoute =
  AuthorizedTeamNotificationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthorizedTeamNotificationsRouteRoute,
  } as any)
const AuthorizedTeamBillingIndexRoute =
  AuthorizedTeamBillingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthorizedTeamBillingRouteRoute,
  } as any)
const AuthorizedAdminUsersIndexRoute =
  AuthorizedAdminUsersIndexRouteImport.update({
    id: '/admin/users/',
    path: '/admin/users/',
    getParentRoute: () => AuthorizedRoute,
  } as any)
const AuthorizedAdminTeamsIndexRoute =
  AuthorizedAdminTeamsIndexRouteImport.update({
    id: '/admin/teams/',
    path: '/admin/teams/',
    getParentRoute: () => AuthorizedRoute,
  } as any)
const MarketingLegalSlugVersionIdRoute =
  MarketingLegalSlugVersionIdRouteImport.update({
    id: '/$versionId',
    path: '/$versionId',
    getParentRoute: () => MarketingLegalSlugRouteRoute,
  } as any)
const MarketingDevelopersApiSplatRoute =
  MarketingDevelopersApiSplatRouteImport.update({
    id: '/developers/api/$',
    path: '/developers/api/$',
    getParentRoute: () => MarketingRoute,
  } as any)
const DocsDocsKnowledgeBaseSlugRoute =
  DocsDocsKnowledgeBaseSlugRouteImport.update({
    id: '/docs/knowledge-base/$slug',
    path: '/docs/knowledge-base/$slug',
    getParentRoute: () => DocsRoute,
  } as any)
const DocsDocsApiReferenceSplatRoute =
  DocsDocsApiReferenceSplatRouteImport.update({
    id: '/docs/api-reference/$',
    path: '/docs/api-reference/$',
    getParentRoute: () => DocsRoute,
  } as any).lazy(() =>
    import('./routes/_docs/docs/api-reference/$.lazy').then((d) => d.Route),
  )
const AuthorizedUserVerifyEmailTokenRoute =
  AuthorizedUserVerifyEmailTokenRouteImport.update({
    id: '/user/verify-email/$token',
    path: '/user/verify-email/$token',
    getParentRoute: () => AuthorizedRoute,
  } as any)
const AuthorizedTeamSettingsApiKeysRoute =
  AuthorizedTeamSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AuthorizedTeamSettingsRouteRoute,
  } as any)
const AuthorizedTeamNotificationsRulesRoute =
  AuthorizedTeamNotificationsRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => AuthorizedTeamNotificationsRouteRoute,
  } as any)
const AuthorizedTeamNotificationsChannelsRoute =
  AuthorizedTeamNotificationsChannelsRouteImport.update({
    id: '/channels',
    path: '/channels',
    getParentRoute: () => AuthorizedTeamNotificationsRouteRoute,
  } as any)
const AuthorizedTeamBillingUsageRoute =
  AuthorizedTeamBillingUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthorizedTeamBillingRouteRoute,
  } as any)
const AuthorizedAdminUsersUserIdRoute =
  AuthorizedAdminUsersUserIdRouteImport.update({
    id: '/admin/users/$userId',
    path: '/admin/users/$userId',
    getParentRoute: () => AuthorizedRoute,
  } as any)
const AuthorizedAdminTeamsTeamIdRoute =
  AuthorizedAdminTeamsTeamIdRouteImport.update({
    id: '/admin/teams/$teamId',
    path: '/admin/teams/$teamId',
    getParentRoute: () => AuthorizedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof MarketingIndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/team': typeof AuthorizedTeamRouteRouteWithChildren
  '/dashboard': typeof AuthorizedDashboardRoute
  '/403': typeof Error403Route
  '/404': typeof Error404Route
  '/500': typeof Error500Route
  '/contact': typeof MarketingContactRoute
  '/download': typeof MarketingDownloadRoute
  '/features': typeof MarketingFeaturesRoute
  '/free-tools': typeof MarketingFreeToolsRoute
  '/pricing': typeof MarketingPricingRoute
  '/transparency': typeof MarketingTransparencyRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/auth/register': typeof AuthRegisterRoute
  '/team/billing': typeof AuthorizedTeamBillingRouteRouteWithChildren
  '/team/notifications': typeof AuthorizedTeamNotificationsRouteRouteWithChildren
  '/team/settings': typeof AuthorizedTeamSettingsRouteRouteWithChildren
  '/legal/$slug': typeof MarketingLegalSlugRouteRouteWithChildren
  '/team/members': typeof AuthorizedTeamMembersRoute
  '/team/security': typeof AuthorizedTeamSecurityRoute
  '/user/security': typeof AuthorizedUserSecurityRoute
  '/user/settings': typeof AuthorizedUserSettingsRoute
  '/user/teams': typeof AuthorizedUserTeamsRoute
  '/docs/$slug': typeof DocsDocsSlugRoute
  '/alternatives/10minutemail': typeof MarketingAlternatives10minutemailRoute
  '/alternatives/guerrilla-mail': typeof MarketingAlternativesGuerrillaMailRoute
  '/alternatives/mailinator': typeof MarketingAlternativesMailinatorRoute
  '/alternatives/temp-mail': typeof MarketingAlternativesTempMailRoute
  '/blog/$path': typeof MarketingBlogPathRoute
  '/changelog/$version': typeof MarketingChangelogVersionRoute
  '/changelog/archive': typeof MarketingChangelogArchiveRoute
  '/developers/webhooks': typeof MarketingDevelopersWebhooksRoute
  '/for/no-registration': typeof MarketingForNoRegistrationRoute
  '/for/sign-up': typeof MarketingForSignUpRoute
  '/for/testing': typeof MarketingForTestingRoute
  '/inbox/$localPart': typeof MarketingInboxLocalPartRoute
  '/auth/github/callback': typeof AuthGithubCallbackRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/auth/mfa/required': typeof AuthMfaRequiredRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/auth/verify-email/$token': typeof AuthVerifyEmailTokenRoute
  '/admin/': typeof AuthorizedAdminIndexRoute
  '/docs/': typeof DocsDocsIndexRoute
  '/blog/': typeof MarketingBlogIndexRoute
  '/changelog/': typeof MarketingChangelogIndexRoute
  '/developers/': typeof MarketingDevelopersIndexRoute
  '/legal/': typeof MarketingLegalIndexRoute
  '/tools/': typeof MarketingToolsIndexRoute
  '/auth/reset-password/': typeof AuthResetPasswordIndexRoute
  '/auth/verify-email/': typeof AuthVerifyEmailIndexRoute
  '/admin/teams/$teamId': typeof AuthorizedAdminTeamsTeamIdRoute
  '/admin/users/$userId': typeof AuthorizedAdminUsersUserIdRoute
  '/team/billing/usage': typeof AuthorizedTeamBillingUsageRoute
  '/team/notifications/channels': typeof AuthorizedTeamNotificationsChannelsRoute
  '/team/notifications/rules': typeof AuthorizedTeamNotificationsRulesRoute
  '/team/settings/api-keys': typeof AuthorizedTeamSettingsApiKeysRoute
  '/user/verify-email/$token': typeof AuthorizedUserVerifyEmailTokenRoute
  '/docs/api-reference/$': typeof DocsDocsApiReferenceSplatRoute
  '/docs/knowledge-base/$slug': typeof DocsDocsKnowledgeBaseSlugRoute
  '/developers/api/$': typeof MarketingDevelopersApiSplatRoute
  '/legal/$slug/$versionId': typeof MarketingLegalSlugVersionIdRoute
  '/admin/teams/': typeof AuthorizedAdminTeamsIndexRoute
  '/admin/users/': typeof AuthorizedAdminUsersIndexRoute
  '/team/billing/': typeof AuthorizedTeamBillingIndexRoute
  '/team/notifications/': typeof AuthorizedTeamNotificationsIndexRoute
  '/team/settings/': typeof AuthorizedTeamSettingsIndexRoute
  '/docs/api-reference/': typeof DocsDocsApiReferenceIndexRoute
  '/docs/knowledge-base/': typeof DocsDocsKnowledgeBaseIndexRoute
  '/developers/api/': typeof MarketingDevelopersApiIndexRoute
  '/legal/$slug/': typeof MarketingLegalSlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof MarketingIndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/team': typeof AuthorizedTeamRouteRouteWithChildren
  '/dashboard': typeof AuthorizedDashboardRoute
  '/403': typeof Error403Route
  '/404': typeof Error404Route
  '/500': typeof Error500Route
  '/contact': typeof MarketingContactRoute
  '/download': typeof MarketingDownloadRoute
  '/features': typeof MarketingFeaturesRoute
  '/free-tools': typeof MarketingFreeToolsRoute
  '/pricing': typeof MarketingPricingRoute
  '/transparency': typeof MarketingTransparencyRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/auth/register': typeof AuthRegisterRoute
  '/team/members': typeof AuthorizedTeamMembersRoute
  '/team/security': typeof AuthorizedTeamSecurityRoute
  '/user/security': typeof AuthorizedUserSecurityRoute
  '/user/settings': typeof AuthorizedUserSettingsRoute
  '/user/teams': typeof AuthorizedUserTeamsRoute
  '/docs/$slug': typeof DocsDocsSlugRoute
  '/alternatives/10minutemail': typeof MarketingAlternatives10minutemailRoute
  '/alternatives/guerrilla-mail': typeof MarketingAlternativesGuerrillaMailRoute
  '/alternatives/mailinator': typeof MarketingAlternativesMailinatorRoute
  '/alternatives/temp-mail': typeof MarketingAlternativesTempMailRoute
  '/blog/$path': typeof MarketingBlogPathRoute
  '/changelog/$version': typeof MarketingChangelogVersionRoute
  '/changelog/archive': typeof MarketingChangelogArchiveRoute
  '/developers/webhooks': typeof MarketingDevelopersWebhooksRoute
  '/for/no-registration': typeof MarketingForNoRegistrationRoute
  '/for/sign-up': typeof MarketingForSignUpRoute
  '/for/testing': typeof MarketingForTestingRoute
  '/inbox/$localPart': typeof MarketingInboxLocalPartRoute
  '/auth/github/callback': typeof AuthGithubCallbackRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/auth/mfa/required': typeof AuthMfaRequiredRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/auth/verify-email/$token': typeof AuthVerifyEmailTokenRoute
  '/admin': typeof AuthorizedAdminIndexRoute
  '/docs': typeof DocsDocsIndexRoute
  '/blog': typeof MarketingBlogIndexRoute
  '/changelog': typeof MarketingChangelogIndexRoute
  '/developers': typeof MarketingDevelopersIndexRoute
  '/legal': typeof MarketingLegalIndexRoute
  '/tools': typeof MarketingToolsIndexRoute
  '/auth/reset-password': typeof AuthResetPasswordIndexRoute
  '/auth/verify-email': typeof AuthVerifyEmailIndexRoute
  '/admin/teams/$teamId': typeof AuthorizedAdminTeamsTeamIdRoute
  '/admin/users/$userId': typeof AuthorizedAdminUsersUserIdRoute
  '/team/billing/usage': typeof AuthorizedTeamBillingUsageRoute
  '/team/notifications/channels': typeof AuthorizedTeamNotificationsChannelsRoute
  '/team/notifications/rules': typeof AuthorizedTeamNotificationsRulesRoute
  '/team/settings/api-keys': typeof AuthorizedTeamSettingsApiKeysRoute
  '/user/verify-email/$token': typeof AuthorizedUserVerifyEmailTokenRoute
  '/docs/api-reference/$': typeof DocsDocsApiReferenceSplatRoute
  '/docs/knowledge-base/$slug': typeof DocsDocsKnowledgeBaseSlugRoute
  '/developers/api/$': typeof MarketingDevelopersApiSplatRoute
  '/legal/$slug/$versionId': typeof MarketingLegalSlugVersionIdRoute
  '/admin/teams': typeof AuthorizedAdminTeamsIndexRoute
  '/admin/users': typeof AuthorizedAdminUsersIndexRoute
  '/team/billing': typeof AuthorizedTeamBillingIndexRoute
  '/team/notifications': typeof AuthorizedTeamNotificationsIndexRoute
  '/team/settings': typeof AuthorizedTeamSettingsIndexRoute
  '/docs/api-reference': typeof DocsDocsApiReferenceIndexRoute
  '/docs/knowledge-base': typeof DocsDocsKnowledgeBaseIndexRoute
  '/developers/api': typeof MarketingDevelopersApiIndexRoute
  '/legal/$slug': typeof MarketingLegalSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authorized': typeof AuthorizedRouteWithChildren
  '/_docs': typeof DocsRouteWithChildren
  '/_error': typeof ErrorRouteWithChildren
  '/_marketing': typeof MarketingRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/_authorized/team': typeof AuthorizedTeamRouteRouteWithChildren
  '/_authorized/dashboard': typeof AuthorizedDashboardRoute
  '/_error/403': typeof Error403Route
  '/_error/404': typeof Error404Route
  '/_error/500': typeof Error500Route
  '/_marketing/contact': typeof MarketingContactRoute
  '/_marketing/download': typeof MarketingDownloadRoute
  '/_marketing/features': typeof MarketingFeaturesRoute
  '/_marketing/free-tools': typeof MarketingFreeToolsRoute
  '/_marketing/pricing': typeof MarketingPricingRoute
  '/_marketing/transparency': typeof MarketingTransparencyRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/auth/register': typeof AuthRegisterRoute
  '/_marketing/': typeof MarketingIndexRoute
  '/_authorized/team/billing': typeof AuthorizedTeamBillingRouteRouteWithChildren
  '/_authorized/team/notifications': typeof AuthorizedTeamNotificationsRouteRouteWithChildren
  '/_authorized/team/settings': typeof AuthorizedTeamSettingsRouteRouteWithChildren
  '/_marketing/legal/$slug': typeof MarketingLegalSlugRouteRouteWithChildren
  '/_authorized/team/members': typeof AuthorizedTeamMembersRoute
  '/_authorized/team/security': typeof AuthorizedTeamSecurityRoute
  '/_authorized/user/security': typeof AuthorizedUserSecurityRoute
  '/_authorized/user/settings': typeof AuthorizedUserSettingsRoute
  '/_authorized/user/teams': typeof AuthorizedUserTeamsRoute
  '/_docs/docs/$slug': typeof DocsDocsSlugRoute
  '/_marketing/alternatives/10minutemail': typeof MarketingAlternatives10minutemailRoute
  '/_marketing/alternatives/guerrilla-mail': typeof MarketingAlternativesGuerrillaMailRoute
  '/_marketing/alternatives/mailinator': typeof MarketingAlternativesMailinatorRoute
  '/_marketing/alternatives/temp-mail': typeof MarketingAlternativesTempMailRoute
  '/_marketing/blog/$path': typeof MarketingBlogPathRoute
  '/_marketing/changelog/$version': typeof MarketingChangelogVersionRoute
  '/_marketing/changelog/archive': typeof MarketingChangelogArchiveRoute
  '/_marketing/developers/webhooks': typeof MarketingDevelopersWebhooksRoute
  '/_marketing/for/no-registration': typeof MarketingForNoRegistrationRoute
  '/_marketing/for/sign-up': typeof MarketingForSignUpRoute
  '/_marketing/for/testing': typeof MarketingForTestingRoute
  '/_marketing/inbox/$localPart': typeof MarketingInboxLocalPartRoute
  '/auth/github/callback': typeof AuthGithubCallbackRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/auth/mfa/required': typeof AuthMfaRequiredRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/auth/verify-email/$token': typeof AuthVerifyEmailTokenRoute
  '/_authorized/admin/': typeof AuthorizedAdminIndexRoute
  '/_docs/docs/': typeof DocsDocsIndexRoute
  '/_marketing/blog/': typeof MarketingBlogIndexRoute
  '/_marketing/changelog/': typeof MarketingChangelogIndexRoute
  '/_marketing/developers/': typeof MarketingDevelopersIndexRoute
  '/_marketing/legal/': typeof MarketingLegalIndexRoute
  '/_marketing/tools/': typeof MarketingToolsIndexRoute
  '/auth/reset-password/': typeof AuthResetPasswordIndexRoute
  '/auth/verify-email/': typeof AuthVerifyEmailIndexRoute
  '/_authorized/admin/teams/$teamId': typeof AuthorizedAdminTeamsTeamIdRoute
  '/_authorized/admin/users/$userId': typeof AuthorizedAdminUsersUserIdRoute
  '/_authorized/team/billing/usage': typeof AuthorizedTeamBillingUsageRoute
  '/_authorized/team/notifications/channels': typeof AuthorizedTeamNotificationsChannelsRoute
  '/_authorized/team/notifications/rules': typeof AuthorizedTeamNotificationsRulesRoute
  '/_authorized/team/settings/api-keys': typeof AuthorizedTeamSettingsApiKeysRoute
  '/_authorized/user/verify-email/$token': typeof AuthorizedUserVerifyEmailTokenRoute
  '/_docs/docs/api-reference/$': typeof DocsDocsApiReferenceSplatRoute
  '/_docs/docs/knowledge-base/$slug': typeof DocsDocsKnowledgeBaseSlugRoute
  '/_marketing/developers/api/$': typeof MarketingDevelopersApiSplatRoute
  '/_marketing/legal/$slug/$versionId': typeof MarketingLegalSlugVersionIdRoute
  '/_authorized/admin/teams/': typeof AuthorizedAdminTeamsIndexRoute
  '/_authorized/admin/users/': typeof AuthorizedAdminUsersIndexRoute
  '/_authorized/team/billing/': typeof AuthorizedTeamBillingIndexRoute
  '/_authorized/team/notifications/': typeof AuthorizedTeamNotificationsIndexRoute
  '/_authorized/team/settings/': typeof AuthorizedTeamSettingsIndexRoute
  '/_docs/docs/api-reference/': typeof DocsDocsApiReferenceIndexRoute
  '/_docs/docs/knowledge-base/': typeof DocsDocsKnowledgeBaseIndexRoute
  '/_marketing/developers/api/': typeof MarketingDevelopersApiIndexRoute
  '/_marketing/legal/$slug/': typeof MarketingLegalSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/team'
    | '/dashboard'
    | '/403'
    | '/404'
    | '/500'
    | '/contact'
    | '/download'
    | '/features'
    | '/free-tools'
    | '/pricing'
    | '/transparency'
    | '/auth/login'
    | '/auth/password-reset'
    | '/auth/register'
    | '/team/billing'
    | '/team/notifications'
    | '/team/settings'
    | '/legal/$slug'
    | '/team/members'
    | '/team/security'
    | '/user/security'
    | '/user/settings'
    | '/user/teams'
    | '/docs/$slug'
    | '/alternatives/10minutemail'
    | '/alternatives/guerrilla-mail'
    | '/alternatives/mailinator'
    | '/alternatives/temp-mail'
    | '/blog/$path'
    | '/changelog/$version'
    | '/changelog/archive'
    | '/developers/webhooks'
    | '/for/no-registration'
    | '/for/sign-up'
    | '/for/testing'
    | '/inbox/$localPart'
    | '/auth/github/callback'
    | '/auth/google/callback'
    | '/auth/mfa/required'
    | '/auth/reset-password/$token'
    | '/auth/verify-email/$token'
    | '/admin/'
    | '/docs/'
    | '/blog/'
    | '/changelog/'
    | '/developers/'
    | '/legal/'
    | '/tools/'
    | '/auth/reset-password/'
    | '/auth/verify-email/'
    | '/admin/teams/$teamId'
    | '/admin/users/$userId'
    | '/team/billing/usage'
    | '/team/notifications/channels'
    | '/team/notifications/rules'
    | '/team/settings/api-keys'
    | '/user/verify-email/$token'
    | '/docs/api-reference/$'
    | '/docs/knowledge-base/$slug'
    | '/developers/api/$'
    | '/legal/$slug/$versionId'
    | '/admin/teams/'
    | '/admin/users/'
    | '/team/billing/'
    | '/team/notifications/'
    | '/team/settings/'
    | '/docs/api-reference/'
    | '/docs/knowledge-base/'
    | '/developers/api/'
    | '/legal/$slug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/team'
    | '/dashboard'
    | '/403'
    | '/404'
    | '/500'
    | '/contact'
    | '/download'
    | '/features'
    | '/free-tools'
    | '/pricing'
    | '/transparency'
    | '/auth/login'
    | '/auth/password-reset'
    | '/auth/register'
    | '/team/members'
    | '/team/security'
    | '/user/security'
    | '/user/settings'
    | '/user/teams'
    | '/docs/$slug'
    | '/alternatives/10minutemail'
    | '/alternatives/guerrilla-mail'
    | '/alternatives/mailinator'
    | '/alternatives/temp-mail'
    | '/blog/$path'
    | '/changelog/$version'
    | '/changelog/archive'
    | '/developers/webhooks'
    | '/for/no-registration'
    | '/for/sign-up'
    | '/for/testing'
    | '/inbox/$localPart'
    | '/auth/github/callback'
    | '/auth/google/callback'
    | '/auth/mfa/required'
    | '/auth/reset-password/$token'
    | '/auth/verify-email/$token'
    | '/admin'
    | '/docs'
    | '/blog'
    | '/changelog'
    | '/developers'
    | '/legal'
    | '/tools'
    | '/auth/reset-password'
    | '/auth/verify-email'
    | '/admin/teams/$teamId'
    | '/admin/users/$userId'
    | '/team/billing/usage'
    | '/team/notifications/channels'
    | '/team/notifications/rules'
    | '/team/settings/api-keys'
    | '/user/verify-email/$token'
    | '/docs/api-reference/$'
    | '/docs/knowledge-base/$slug'
    | '/developers/api/$'
    | '/legal/$slug/$versionId'
    | '/admin/teams'
    | '/admin/users'
    | '/team/billing'
    | '/team/notifications'
    | '/team/settings'
    | '/docs/api-reference'
    | '/docs/knowledge-base'
    | '/developers/api'
    | '/legal/$slug'
  id:
    | '__root__'
    | '/_authorized'
    | '/_docs'
    | '/_error'
    | '/_marketing'
    | '/auth'
    | '/_authorized/team'
    | '/_authorized/dashboard'
    | '/_error/403'
    | '/_error/404'
    | '/_error/500'
    | '/_marketing/contact'
    | '/_marketing/download'
    | '/_marketing/features'
    | '/_marketing/free-tools'
    | '/_marketing/pricing'
    | '/_marketing/transparency'
    | '/auth/login'
    | '/auth/password-reset'
    | '/auth/register'
    | '/_marketing/'
    | '/_authorized/team/billing'
    | '/_authorized/team/notifications'
    | '/_authorized/team/settings'
    | '/_marketing/legal/$slug'
    | '/_authorized/team/members'
    | '/_authorized/team/security'
    | '/_authorized/user/security'
    | '/_authorized/user/settings'
    | '/_authorized/user/teams'
    | '/_docs/docs/$slug'
    | '/_marketing/alternatives/10minutemail'
    | '/_marketing/alternatives/guerrilla-mail'
    | '/_marketing/alternatives/mailinator'
    | '/_marketing/alternatives/temp-mail'
    | '/_marketing/blog/$path'
    | '/_marketing/changelog/$version'
    | '/_marketing/changelog/archive'
    | '/_marketing/developers/webhooks'
    | '/_marketing/for/no-registration'
    | '/_marketing/for/sign-up'
    | '/_marketing/for/testing'
    | '/_marketing/inbox/$localPart'
    | '/auth/github/callback'
    | '/auth/google/callback'
    | '/auth/mfa/required'
    | '/auth/reset-password/$token'
    | '/auth/verify-email/$token'
    | '/_authorized/admin/'
    | '/_docs/docs/'
    | '/_marketing/blog/'
    | '/_marketing/changelog/'
    | '/_marketing/developers/'
    | '/_marketing/legal/'
    | '/_marketing/tools/'
    | '/auth/reset-password/'
    | '/auth/verify-email/'
    | '/_authorized/admin/teams/$teamId'
    | '/_authorized/admin/users/$userId'
    | '/_authorized/team/billing/usage'
    | '/_authorized/team/notifications/channels'
    | '/_authorized/team/notifications/rules'
    | '/_authorized/team/settings/api-keys'
    | '/_authorized/user/verify-email/$token'
    | '/_docs/docs/api-reference/$'
    | '/_docs/docs/knowledge-base/$slug'
    | '/_marketing/developers/api/$'
    | '/_marketing/legal/$slug/$versionId'
    | '/_authorized/admin/teams/'
    | '/_authorized/admin/users/'
    | '/_authorized/team/billing/'
    | '/_authorized/team/notifications/'
    | '/_authorized/team/settings/'
    | '/_docs/docs/api-reference/'
    | '/_docs/docs/knowledge-base/'
    | '/_marketing/developers/api/'
    | '/_marketing/legal/$slug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthorizedRoute: typeof AuthorizedRouteWithChildren
  DocsRoute: typeof DocsRouteWithChildren
  ErrorRoute: typeof ErrorRouteWithChildren
  MarketingRoute: typeof MarketingRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing': {
      id: '/_marketing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_error': {
      id: '/_error'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_docs': {
      id: '/_docs'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authorized': {
      id: '/_authorized'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing/': {
      id: '/_marketing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/password-reset': {
      id: '/auth/password-reset'
      path: '/password-reset'
      fullPath: '/auth/password-reset'
      preLoaderRoute: typeof AuthPasswordResetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_marketing/transparency': {
      id: '/_marketing/transparency'
      path: '/transparency'
      fullPath: '/transparency'
      preLoaderRoute: typeof MarketingTransparencyRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/pricing': {
      id: '/_marketing/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof MarketingPricingRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/free-tools': {
      id: '/_marketing/free-tools'
      path: '/free-tools'
      fullPath: '/free-tools'
      preLoaderRoute: typeof MarketingFreeToolsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/features': {
      id: '/_marketing/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof MarketingFeaturesRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/download': {
      id: '/_marketing/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof MarketingDownloadRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/contact': {
      id: '/_marketing/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof MarketingContactRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_error/500': {
      id: '/_error/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof Error500RouteImport
      parentRoute: typeof ErrorRoute
    }
    '/_error/404': {
      id: '/_error/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof Error404RouteImport
      parentRoute: typeof ErrorRoute
    }
    '/_error/403': {
      id: '/_error/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof Error403RouteImport
      parentRoute: typeof ErrorRoute
    }
    '/_authorized/dashboard': {
      id: '/_authorized/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthorizedDashboardRouteImport
      parentRoute: typeof AuthorizedRoute
    }
    '/_authorized/team': {
      id: '/_authorized/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AuthorizedTeamRouteRouteImport
      parentRoute: typeof AuthorizedRoute
    }
    '/auth/verify-email/': {
      id: '/auth/verify-email/'
      path: '/verify-email'
      fullPath: '/auth/verify-email/'
      preLoaderRoute: typeof AuthVerifyEmailIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/reset-password/': {
      id: '/auth/reset-password/'
      path: '/reset-password'
      fullPath: '/auth/reset-password/'
      preLoaderRoute: typeof AuthResetPasswordIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_marketing/tools/': {
      id: '/_marketing/tools/'
      path: '/tools'
      fullPath: '/tools/'
      preLoaderRoute: typeof MarketingToolsIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/legal/': {
      id: '/_marketing/legal/'
      path: '/legal'
      fullPath: '/legal/'
      preLoaderRoute: typeof MarketingLegalIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/developers/': {
      id: '/_marketing/developers/'
      path: '/developers'
      fullPath: '/developers/'
      preLoaderRoute: typeof MarketingDevelopersIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/changelog/': {
      id: '/_marketing/changelog/'
      path: '/changelog'
      fullPath: '/changelog/'
      preLoaderRoute: typeof MarketingChangelogIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/blog/': {
      id: '/_marketing/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof MarketingBlogIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_docs/docs/': {
      id: '/_docs/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsDocsIndexRouteImport
      parentRoute: typeof DocsRoute
    }
    '/_authorized/admin/': {
      id: '/_authorized/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthorizedAdminIndexRouteImport
      parentRoute: typeof AuthorizedRoute
    }
    '/auth/verify-email/$token': {
      id: '/auth/verify-email/$token'
      path: '/verify-email/$token'
      fullPath: '/auth/verify-email/$token'
      preLoaderRoute: typeof AuthVerifyEmailTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/reset-password/$token': {
      id: '/auth/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/auth/reset-password/$token'
      preLoaderRoute: typeof AuthResetPasswordTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/mfa/required': {
      id: '/auth/mfa/required'
      path: '/mfa/required'
      fullPath: '/auth/mfa/required'
      preLoaderRoute: typeof AuthMfaRequiredRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/google/callback': {
      id: '/auth/google/callback'
      path: '/google/callback'
      fullPath: '/auth/google/callback'
      preLoaderRoute: typeof AuthGoogleCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/github/callback': {
      id: '/auth/github/callback'
      path: '/github/callback'
      fullPath: '/auth/github/callback'
      preLoaderRoute: typeof AuthGithubCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_marketing/inbox/$localPart': {
      id: '/_marketing/inbox/$localPart'
      path: '/inbox/$localPart'
      fullPath: '/inbox/$localPart'
      preLoaderRoute: typeof MarketingInboxLocalPartRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/for/testing': {
      id: '/_marketing/for/testing'
      path: '/for/testing'
      fullPath: '/for/testing'
      preLoaderRoute: typeof MarketingForTestingRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/for/sign-up': {
      id: '/_marketing/for/sign-up'
      path: '/for/sign-up'
      fullPath: '/for/sign-up'
      preLoaderRoute: typeof MarketingForSignUpRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/for/no-registration': {
      id: '/_marketing/for/no-registration'
      path: '/for/no-registration'
      fullPath: '/for/no-registration'
      preLoaderRoute: typeof MarketingForNoRegistrationRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/developers/webhooks': {
      id: '/_marketing/developers/webhooks'
      path: '/developers/webhooks'
      fullPath: '/developers/webhooks'
      preLoaderRoute: typeof MarketingDevelopersWebhooksRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/changelog/archive': {
      id: '/_marketing/changelog/archive'
      path: '/changelog/archive'
      fullPath: '/changelog/archive'
      preLoaderRoute: typeof MarketingChangelogArchiveRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/changelog/$version': {
      id: '/_marketing/changelog/$version'
      path: '/changelog/$version'
      fullPath: '/changelog/$version'
      preLoaderRoute: typeof MarketingChangelogVersionRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/blog/$path': {
      id: '/_marketing/blog/$path'
      path: '/blog/$path'
      fullPath: '/blog/$path'
      preLoaderRoute: typeof MarketingBlogPathRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/alternatives/temp-mail': {
      id: '/_marketing/alternatives/temp-mail'
      path: '/alternatives/temp-mail'
      fullPath: '/alternatives/temp-mail'
      preLoaderRoute: typeof MarketingAlternativesTempMailRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/alternatives/mailinator': {
      id: '/_marketing/alternatives/mailinator'
      path: '/alternatives/mailinator'
      fullPath: '/alternatives/mailinator'
      preLoaderRoute: typeof MarketingAlternativesMailinatorRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/alternatives/guerrilla-mail': {
      id: '/_marketing/alternatives/guerrilla-mail'
      path: '/alternatives/guerrilla-mail'
      fullPath: '/alternatives/guerrilla-mail'
      preLoaderRoute: typeof MarketingAlternativesGuerrillaMailRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/alternatives/10minutemail': {
      id: '/_marketing/alternatives/10minutemail'
      path: '/alternatives/10minutemail'
      fullPath: '/alternatives/10minutemail'
      preLoaderRoute: typeof MarketingAlternatives10minutemailRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_docs/docs/$slug': {
      id: '/_docs/docs/$slug'
      path: '/docs/$slug'
      fullPath: '/docs/$slug'
      preLoaderRoute: typeof DocsDocsSlugRouteImport
      parentRoute: typeof DocsRoute
    }
    '/_authorized/user/teams': {
      id: '/_authorized/user/teams'
      path: '/user/teams'
      fullPath: '/user/teams'
      preLoaderRoute: typeof AuthorizedUserTeamsRouteImport
      parentRoute: typeof AuthorizedRoute
    }
    '/_authorized/user/settings': {
      id: '/_authorized/user/settings'
      path: '/user/settings'
      fullPath: '/user/settings'
      preLoaderRoute: typeof AuthorizedUserSettingsRouteImport
      parentRoute: typeof AuthorizedRoute
    }
    '/_authorized/user/security': {
      id: '/_authorized/user/security'
      path: '/user/security'
      fullPath: '/user/security'
      preLoaderRoute: typeof AuthorizedUserSecurityRouteImport
      parentRoute: typeof AuthorizedRoute
    }
    '/_authorized/team/security': {
      id: '/_authorized/team/security'
      path: '/security'
      fullPath: '/team/security'
      preLoaderRoute: typeof AuthorizedTeamSecurityRouteImport
      parentRoute: typeof AuthorizedTeamRouteRoute
    }
    '/_authorized/team/members': {
      id: '/_authorized/team/members'
      path: '/members'
      fullPath: '/team/members'
      preLoaderRoute: typeof AuthorizedTeamMembersRouteImport
      parentRoute: typeof AuthorizedTeamRouteRoute
    }
    '/_marketing/legal/$slug': {
      id: '/_marketing/legal/$slug'
      path: '/legal/$slug'
      fullPath: '/legal/$slug'
      preLoaderRoute: typeof MarketingLegalSlugRouteRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_authorized/team/settings': {
      id: '/_authorized/team/settings'
      path: '/settings'
      fullPath: '/team/settings'
      preLoaderRoute: typeof AuthorizedTeamSettingsRouteRouteImport
      parentRoute: typeof AuthorizedTeamRouteRoute
    }
    '/_authorized/team/notifications': {
      id: '/_authorized/team/notifications'
      path: '/notifications'
      fullPath: '/team/notifications'
      preLoaderRoute: typeof AuthorizedTeamNotificationsRouteRouteImport
      parentRoute: typeof AuthorizedTeamRouteRoute
    }
    '/_authorized/team/billing': {
      id: '/_authorized/team/billing'
      path: '/billing'
      fullPath: '/team/billing'
      preLoaderRoute: typeof AuthorizedTeamBillingRouteRouteImport
      parentRoute: typeof AuthorizedTeamRouteRoute
    }
    '/_marketing/legal/$slug/': {
      id: '/_marketing/legal/$slug/'
      path: '/'
      fullPath: '/legal/$slug/'
      preLoaderRoute: typeof MarketingLegalSlugIndexRouteImport
      parentRoute: typeof MarketingLegalSlugRouteRoute
    }
    '/_marketing/developers/api/': {
      id: '/_marketing/developers/api/'
      path: '/developers/api'
      fullPath: '/developers/api/'
      preLoaderRoute: typeof MarketingDevelopersApiIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_docs/docs/knowledge-base/': {
      id: '/_docs/docs/knowledge-base/'
      path: '/docs/knowledge-base'
      fullPath: '/docs/knowledge-base/'
      preLoaderRoute: typeof DocsDocsKnowledgeBaseIndexRouteImport
      parentRoute: typeof DocsRoute
    }
    '/_docs/docs/api-reference/': {
      id: '/_docs/docs/api-reference/'
      path: '/docs/api-reference'
      fullPath: '/docs/api-reference/'
      preLoaderRoute: typeof DocsDocsApiReferenceIndexRouteImport
      parentRoute: typeof DocsRoute
    }
    '/_authorized/team/settings/': {
      id: '/_authorized/team/settings/'
      path: '/'
      fullPath: '/team/settings/'
      preLoaderRoute: typeof AuthorizedTeamSettingsIndexRouteImport
      parentRoute: typeof AuthorizedTeamSettingsRouteRoute
    }
    '/_authorized/team/notifications/': {
      id: '/_authorized/team/notifications/'
      path: '/'
      fullPath: '/team/notifications/'
      preLoaderRoute: typeof AuthorizedTeamNotificationsIndexRouteImport
      parentRoute: typeof AuthorizedTeamNotificationsRouteRoute
    }
    '/_authorized/team/billing/': {
      id: '/_authorized/team/billing/'
      path: '/'
      fullPath: '/team/billing/'
      preLoaderRoute: typeof AuthorizedTeamBillingIndexRouteImport
      parentRoute: typeof AuthorizedTeamBillingRouteRoute
    }
    '/_authorized/admin/users/': {
      id: '/_authorized/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthorizedAdminUsersIndexRouteImport
      parentRoute: typeof AuthorizedRoute
    }
    '/_authorized/admin/teams/': {
      id: '/_authorized/admin/teams/'
      path: '/admin/teams'
      fullPath: '/admin/teams/'
      preLoaderRoute: typeof AuthorizedAdminTeamsIndexRouteImport
      parentRoute: typeof AuthorizedRoute
    }
    '/_marketing/legal/$slug/$versionId': {
      id: '/_marketing/legal/$slug/$versionId'
      path: '/$versionId'
      fullPath: '/legal/$slug/$versionId'
      preLoaderRoute: typeof MarketingLegalSlugVersionIdRouteImport
      parentRoute: typeof MarketingLegalSlugRouteRoute
    }
    '/_marketing/developers/api/$': {
      id: '/_marketing/developers/api/$'
      path: '/developers/api/$'
      fullPath: '/developers/api/$'
      preLoaderRoute: typeof MarketingDevelopersApiSplatRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_docs/docs/knowledge-base/$slug': {
      id: '/_docs/docs/knowledge-base/$slug'
      path: '/docs/knowledge-base/$slug'
      fullPath: '/docs/knowledge-base/$slug'
      preLoaderRoute: typeof DocsDocsKnowledgeBaseSlugRouteImport
      parentRoute: typeof DocsRoute
    }
    '/_docs/docs/api-reference/$': {
      id: '/_docs/docs/api-reference/$'
      path: '/docs/api-reference/$'
      fullPath: '/docs/api-reference/$'
      preLoaderRoute: typeof DocsDocsApiReferenceSplatRouteImport
      parentRoute: typeof DocsRoute
    }
    '/_authorized/user/verify-email/$token': {
      id: '/_authorized/user/verify-email/$token'
      path: '/user/verify-email/$token'
      fullPath: '/user/verify-email/$token'
      preLoaderRoute: typeof AuthorizedUserVerifyEmailTokenRouteImport
      parentRoute: typeof AuthorizedRoute
    }
    '/_authorized/team/settings/api-keys': {
      id: '/_authorized/team/settings/api-keys'
      path: '/api-keys'
      fullPath: '/team/settings/api-keys'
      preLoaderRoute: typeof AuthorizedTeamSettingsApiKeysRouteImport
      parentRoute: typeof AuthorizedTeamSettingsRouteRoute
    }
    '/_authorized/team/notifications/rules': {
      id: '/_authorized/team/notifications/rules'
      path: '/rules'
      fullPath: '/team/notifications/rules'
      preLoaderRoute: typeof AuthorizedTeamNotificationsRulesRouteImport
      parentRoute: typeof AuthorizedTeamNotificationsRouteRoute
    }
    '/_authorized/team/notifications/channels': {
      id: '/_authorized/team/notifications/channels'
      path: '/channels'
      fullPath: '/team/notifications/channels'
      preLoaderRoute: typeof AuthorizedTeamNotificationsChannelsRouteImport
      parentRoute: typeof AuthorizedTeamNotificationsRouteRoute
    }
    '/_authorized/team/billing/usage': {
      id: '/_authorized/team/billing/usage'
      path: '/usage'
      fullPath: '/team/billing/usage'
      preLoaderRoute: typeof AuthorizedTeamBillingUsageRouteImport
      parentRoute: typeof AuthorizedTeamBillingRouteRoute
    }
    '/_authorized/admin/users/$userId': {
      id: '/_authorized/admin/users/$userId'
      path: '/admin/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AuthorizedAdminUsersUserIdRouteImport
      parentRoute: typeof AuthorizedRoute
    }
    '/_authorized/admin/teams/$teamId': {
      id: '/_authorized/admin/teams/$teamId'
      path: '/admin/teams/$teamId'
      fullPath: '/admin/teams/$teamId'
      preLoaderRoute: typeof AuthorizedAdminTeamsTeamIdRouteImport
      parentRoute: typeof AuthorizedRoute
    }
  }
}

interface AuthorizedTeamBillingRouteRouteChildren {
  AuthorizedTeamBillingUsageRoute: typeof AuthorizedTeamBillingUsageRoute
  AuthorizedTeamBillingIndexRoute: typeof AuthorizedTeamBillingIndexRoute
}

const AuthorizedTeamBillingRouteRouteChildren: AuthorizedTeamBillingRouteRouteChildren =
  {
    AuthorizedTeamBillingUsageRoute: AuthorizedTeamBillingUsageRoute,
    AuthorizedTeamBillingIndexRoute: AuthorizedTeamBillingIndexRoute,
  }

const AuthorizedTeamBillingRouteRouteWithChildren =
  AuthorizedTeamBillingRouteRoute._addFileChildren(
    AuthorizedTeamBillingRouteRouteChildren,
  )

interface AuthorizedTeamNotificationsRouteRouteChildren {
  AuthorizedTeamNotificationsChannelsRoute: typeof AuthorizedTeamNotificationsChannelsRoute
  AuthorizedTeamNotificationsRulesRoute: typeof AuthorizedTeamNotificationsRulesRoute
  AuthorizedTeamNotificationsIndexRoute: typeof AuthorizedTeamNotificationsIndexRoute
}

const AuthorizedTeamNotificationsRouteRouteChildren: AuthorizedTeamNotificationsRouteRouteChildren =
  {
    AuthorizedTeamNotificationsChannelsRoute:
      AuthorizedTeamNotificationsChannelsRoute,
    AuthorizedTeamNotificationsRulesRoute:
      AuthorizedTeamNotificationsRulesRoute,
    AuthorizedTeamNotificationsIndexRoute:
      AuthorizedTeamNotificationsIndexRoute,
  }

const AuthorizedTeamNotificationsRouteRouteWithChildren =
  AuthorizedTeamNotificationsRouteRoute._addFileChildren(
    AuthorizedTeamNotificationsRouteRouteChildren,
  )

interface AuthorizedTeamSettingsRouteRouteChildren {
  AuthorizedTeamSettingsApiKeysRoute: typeof AuthorizedTeamSettingsApiKeysRoute
  AuthorizedTeamSettingsIndexRoute: typeof AuthorizedTeamSettingsIndexRoute
}

const AuthorizedTeamSettingsRouteRouteChildren: AuthorizedTeamSettingsRouteRouteChildren =
  {
    AuthorizedTeamSettingsApiKeysRoute: AuthorizedTeamSettingsApiKeysRoute,
    AuthorizedTeamSettingsIndexRoute: AuthorizedTeamSettingsIndexRoute,
  }

const AuthorizedTeamSettingsRouteRouteWithChildren =
  AuthorizedTeamSettingsRouteRoute._addFileChildren(
    AuthorizedTeamSettingsRouteRouteChildren,
  )

interface AuthorizedTeamRouteRouteChildren {
  AuthorizedTeamBillingRouteRoute: typeof AuthorizedTeamBillingRouteRouteWithChildren
  AuthorizedTeamNotificationsRouteRoute: typeof AuthorizedTeamNotificationsRouteRouteWithChildren
  AuthorizedTeamSettingsRouteRoute: typeof AuthorizedTeamSettingsRouteRouteWithChildren
  AuthorizedTeamMembersRoute: typeof AuthorizedTeamMembersRoute
  AuthorizedTeamSecurityRoute: typeof AuthorizedTeamSecurityRoute
}

const AuthorizedTeamRouteRouteChildren: AuthorizedTeamRouteRouteChildren = {
  AuthorizedTeamBillingRouteRoute: AuthorizedTeamBillingRouteRouteWithChildren,
  AuthorizedTeamNotificationsRouteRoute:
    AuthorizedTeamNotificationsRouteRouteWithChildren,
  AuthorizedTeamSettingsRouteRoute:
    AuthorizedTeamSettingsRouteRouteWithChildren,
  AuthorizedTeamMembersRoute: AuthorizedTeamMembersRoute,
  AuthorizedTeamSecurityRoute: AuthorizedTeamSecurityRoute,
}

const AuthorizedTeamRouteRouteWithChildren =
  AuthorizedTeamRouteRoute._addFileChildren(AuthorizedTeamRouteRouteChildren)

interface AuthorizedRouteChildren {
  AuthorizedTeamRouteRoute: typeof AuthorizedTeamRouteRouteWithChildren
  AuthorizedDashboardRoute: typeof AuthorizedDashboardRoute
  AuthorizedUserSecurityRoute: typeof AuthorizedUserSecurityRoute
  AuthorizedUserSettingsRoute: typeof AuthorizedUserSettingsRoute
  AuthorizedUserTeamsRoute: typeof AuthorizedUserTeamsRoute
  AuthorizedAdminIndexRoute: typeof AuthorizedAdminIndexRoute
  AuthorizedAdminTeamsTeamIdRoute: typeof AuthorizedAdminTeamsTeamIdRoute
  AuthorizedAdminUsersUserIdRoute: typeof AuthorizedAdminUsersUserIdRoute
  AuthorizedUserVerifyEmailTokenRoute: typeof AuthorizedUserVerifyEmailTokenRoute
  AuthorizedAdminTeamsIndexRoute: typeof AuthorizedAdminTeamsIndexRoute
  AuthorizedAdminUsersIndexRoute: typeof AuthorizedAdminUsersIndexRoute
}

const AuthorizedRouteChildren: AuthorizedRouteChildren = {
  AuthorizedTeamRouteRoute: AuthorizedTeamRouteRouteWithChildren,
  AuthorizedDashboardRoute: AuthorizedDashboardRoute,
  AuthorizedUserSecurityRoute: AuthorizedUserSecurityRoute,
  AuthorizedUserSettingsRoute: AuthorizedUserSettingsRoute,
  AuthorizedUserTeamsRoute: AuthorizedUserTeamsRoute,
  AuthorizedAdminIndexRoute: AuthorizedAdminIndexRoute,
  AuthorizedAdminTeamsTeamIdRoute: AuthorizedAdminTeamsTeamIdRoute,
  AuthorizedAdminUsersUserIdRoute: AuthorizedAdminUsersUserIdRoute,
  AuthorizedUserVerifyEmailTokenRoute: AuthorizedUserVerifyEmailTokenRoute,
  AuthorizedAdminTeamsIndexRoute: AuthorizedAdminTeamsIndexRoute,
  AuthorizedAdminUsersIndexRoute: AuthorizedAdminUsersIndexRoute,
}

const AuthorizedRouteWithChildren = AuthorizedRoute._addFileChildren(
  AuthorizedRouteChildren,
)

interface DocsRouteChildren {
  DocsDocsSlugRoute: typeof DocsDocsSlugRoute
  DocsDocsIndexRoute: typeof DocsDocsIndexRoute
  DocsDocsApiReferenceSplatRoute: typeof DocsDocsApiReferenceSplatRoute
  DocsDocsKnowledgeBaseSlugRoute: typeof DocsDocsKnowledgeBaseSlugRoute
  DocsDocsApiReferenceIndexRoute: typeof DocsDocsApiReferenceIndexRoute
  DocsDocsKnowledgeBaseIndexRoute: typeof DocsDocsKnowledgeBaseIndexRoute
}

const DocsRouteChildren: DocsRouteChildren = {
  DocsDocsSlugRoute: DocsDocsSlugRoute,
  DocsDocsIndexRoute: DocsDocsIndexRoute,
  DocsDocsApiReferenceSplatRoute: DocsDocsApiReferenceSplatRoute,
  DocsDocsKnowledgeBaseSlugRoute: DocsDocsKnowledgeBaseSlugRoute,
  DocsDocsApiReferenceIndexRoute: DocsDocsApiReferenceIndexRoute,
  DocsDocsKnowledgeBaseIndexRoute: DocsDocsKnowledgeBaseIndexRoute,
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)

interface ErrorRouteChildren {
  Error403Route: typeof Error403Route
  Error404Route: typeof Error404Route
  Error500Route: typeof Error500Route
}

const ErrorRouteChildren: ErrorRouteChildren = {
  Error403Route: Error403Route,
  Error404Route: Error404Route,
  Error500Route: Error500Route,
}

const ErrorRouteWithChildren = ErrorRoute._addFileChildren(ErrorRouteChildren)

interface MarketingLegalSlugRouteRouteChildren {
  MarketingLegalSlugVersionIdRoute: typeof MarketingLegalSlugVersionIdRoute
  MarketingLegalSlugIndexRoute: typeof MarketingLegalSlugIndexRoute
}

const MarketingLegalSlugRouteRouteChildren: MarketingLegalSlugRouteRouteChildren =
  {
    MarketingLegalSlugVersionIdRoute: MarketingLegalSlugVersionIdRoute,
    MarketingLegalSlugIndexRoute: MarketingLegalSlugIndexRoute,
  }

const MarketingLegalSlugRouteRouteWithChildren =
  MarketingLegalSlugRouteRoute._addFileChildren(
    MarketingLegalSlugRouteRouteChildren,
  )

interface MarketingRouteChildren {
  MarketingContactRoute: typeof MarketingContactRoute
  MarketingDownloadRoute: typeof MarketingDownloadRoute
  MarketingFeaturesRoute: typeof MarketingFeaturesRoute
  MarketingFreeToolsRoute: typeof MarketingFreeToolsRoute
  MarketingPricingRoute: typeof MarketingPricingRoute
  MarketingTransparencyRoute: typeof MarketingTransparencyRoute
  MarketingIndexRoute: typeof MarketingIndexRoute
  MarketingLegalSlugRouteRoute: typeof MarketingLegalSlugRouteRouteWithChildren
  MarketingAlternatives10minutemailRoute: typeof MarketingAlternatives10minutemailRoute
  MarketingAlternativesGuerrillaMailRoute: typeof MarketingAlternativesGuerrillaMailRoute
  MarketingAlternativesMailinatorRoute: typeof MarketingAlternativesMailinatorRoute
  MarketingAlternativesTempMailRoute: typeof MarketingAlternativesTempMailRoute
  MarketingBlogPathRoute: typeof MarketingBlogPathRoute
  MarketingChangelogVersionRoute: typeof MarketingChangelogVersionRoute
  MarketingChangelogArchiveRoute: typeof MarketingChangelogArchiveRoute
  MarketingDevelopersWebhooksRoute: typeof MarketingDevelopersWebhooksRoute
  MarketingForNoRegistrationRoute: typeof MarketingForNoRegistrationRoute
  MarketingForSignUpRoute: typeof MarketingForSignUpRoute
  MarketingForTestingRoute: typeof MarketingForTestingRoute
  MarketingInboxLocalPartRoute: typeof MarketingInboxLocalPartRoute
  MarketingBlogIndexRoute: typeof MarketingBlogIndexRoute
  MarketingChangelogIndexRoute: typeof MarketingChangelogIndexRoute
  MarketingDevelopersIndexRoute: typeof MarketingDevelopersIndexRoute
  MarketingLegalIndexRoute: typeof MarketingLegalIndexRoute
  MarketingToolsIndexRoute: typeof MarketingToolsIndexRoute
  MarketingDevelopersApiSplatRoute: typeof MarketingDevelopersApiSplatRoute
  MarketingDevelopersApiIndexRoute: typeof MarketingDevelopersApiIndexRoute
}

const MarketingRouteChildren: MarketingRouteChildren = {
  MarketingContactRoute: MarketingContactRoute,
  MarketingDownloadRoute: MarketingDownloadRoute,
  MarketingFeaturesRoute: MarketingFeaturesRoute,
  MarketingFreeToolsRoute: MarketingFreeToolsRoute,
  MarketingPricingRoute: MarketingPricingRoute,
  MarketingTransparencyRoute: MarketingTransparencyRoute,
  MarketingIndexRoute: MarketingIndexRoute,
  MarketingLegalSlugRouteRoute: MarketingLegalSlugRouteRouteWithChildren,
  MarketingAlternatives10minutemailRoute:
    MarketingAlternatives10minutemailRoute,
  MarketingAlternativesGuerrillaMailRoute:
    MarketingAlternativesGuerrillaMailRoute,
  MarketingAlternativesMailinatorRoute: MarketingAlternativesMailinatorRoute,
  MarketingAlternativesTempMailRoute: MarketingAlternativesTempMailRoute,
  MarketingBlogPathRoute: MarketingBlogPathRoute,
  MarketingChangelogVersionRoute: MarketingChangelogVersionRoute,
  MarketingChangelogArchiveRoute: MarketingChangelogArchiveRoute,
  MarketingDevelopersWebhooksRoute: MarketingDevelopersWebhooksRoute,
  MarketingForNoRegistrationRoute: MarketingForNoRegistrationRoute,
  MarketingForSignUpRoute: MarketingForSignUpRoute,
  MarketingForTestingRoute: MarketingForTestingRoute,
  MarketingInboxLocalPartRoute: MarketingInboxLocalPartRoute,
  MarketingBlogIndexRoute: MarketingBlogIndexRoute,
  MarketingChangelogIndexRoute: MarketingChangelogIndexRoute,
  MarketingDevelopersIndexRoute: MarketingDevelopersIndexRoute,
  MarketingLegalIndexRoute: MarketingLegalIndexRoute,
  MarketingToolsIndexRoute: MarketingToolsIndexRoute,
  MarketingDevelopersApiSplatRoute: MarketingDevelopersApiSplatRoute,
  MarketingDevelopersApiIndexRoute: MarketingDevelopersApiIndexRoute,
}

const MarketingRouteWithChildren = MarketingRoute._addFileChildren(
  MarketingRouteChildren,
)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthPasswordResetRoute: typeof AuthPasswordResetRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthGithubCallbackRoute: typeof AuthGithubCallbackRoute
  AuthGoogleCallbackRoute: typeof AuthGoogleCallbackRoute
  AuthMfaRequiredRoute: typeof AuthMfaRequiredRoute
  AuthResetPasswordTokenRoute: typeof AuthResetPasswordTokenRoute
  AuthVerifyEmailTokenRoute: typeof AuthVerifyEmailTokenRoute
  AuthResetPasswordIndexRoute: typeof AuthResetPasswordIndexRoute
  AuthVerifyEmailIndexRoute: typeof AuthVerifyEmailIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthPasswordResetRoute: AuthPasswordResetRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthGithubCallbackRoute: AuthGithubCallbackRoute,
  AuthGoogleCallbackRoute: AuthGoogleCallbackRoute,
  AuthMfaRequiredRoute: AuthMfaRequiredRoute,
  AuthResetPasswordTokenRoute: AuthResetPasswordTokenRoute,
  AuthVerifyEmailTokenRoute: AuthVerifyEmailTokenRoute,
  AuthResetPasswordIndexRoute: AuthResetPasswordIndexRoute,
  AuthVerifyEmailIndexRoute: AuthVerifyEmailIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthorizedRoute: AuthorizedRouteWithChildren,
  DocsRoute: DocsRouteWithChildren,
  ErrorRoute: ErrorRouteWithChildren,
  MarketingRoute: MarketingRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
